import _ from "lodash";
import React from "react";

import CardSecondary from "../../../UI/Card/CardSecondary";
import images from "../../../../utils/images";
import { TextArea } from "../../../UI/StyledInput";

import { RATING_OPTIONS_LABEL_MAP } from "./MemberProfileNotes";

/**
 * @deprecated [BubbleFillButton] is the new version of [BehavioralGoalsRating, BehavioralGoalsRatingLabelButtons]
 */

export const BehavioralGoalsRating = (props) => {
  const {
    optionLabelMap,
    progress,
    onClick,
    isEditing,
    ratingKey,
    containerClass,
    height = 15,
    labelsEnabled = false,
    labelKey = "label",
  } = props;

  let answerKey = ratingKey ? ratingKey : "answer";
  let containerClasses = containerClass
    ? `${containerClass} col-12 d-flex justify-content-start`
    : "col-12 d-flex justify-content-start";

  return (
    <div className={containerClasses}>
      {Object.keys(optionLabelMap).map((optionId) => {
        optionId = parseInt(optionId);
        let optionsClasses;

        // debugger
        if (progress[answerKey] !== null && progress[answerKey] === optionId) {
          optionsClasses = "RatingOption RatingOption-active w-100";
        } else {
          optionsClasses =
            "RatingOption w-100 " + (props.optionsClasses ? props.optionsClasses : "");
        }

        return (
          <div key={progress[labelKey] + optionId} style={{ margin: "0px 5px" }} className="w-100">
            <button
              style={{ height: height }}
              id={`${optionId}`}
              className={optionsClasses}
              type="button"
              value={optionId}
              onClick={onClick}
              disabled={!isEditing}
            />
            {labelsEnabled && optionLabelMap[optionId] && (
              <label className="d-flex tw:justify-center">{optionLabelMap[optionId]}</label>
            )}
          </div>
        );
      })}
    </div>
  );
};

export const BehavioralGoalsRatingLabelButtons = (props) => {
  const { optionLabelMap, progress, onClick, isEditing, ratingKey } = props;

  let answerKey = ratingKey ? ratingKey : "answer";

  let optionLabelMapValues = Object.values(optionLabelMap);

  return (
    <div style={{ padding: 0 }} className="col-12 d-flex justify-content-start">
      {Object.keys(optionLabelMap).map((optionId, index) => {
        optionId = parseInt(optionId);
        let optionsClasses;

        if (progress[answerKey] !== null && progress[answerKey] === optionId) {
          optionsClasses = "RatingOptionButton RatingOptionButton-active w-100";
        } else {
          optionsClasses =
            "RatingOptionButton w-100 " + (props.optionsClasses ? props.optionsClasses : "");
        }

        return (
          <div key={progress.label + optionId} style={{ margin: "0px 5px" }} className="w-100">
            <button
              style={{ height: 30 }}
              id={`${optionId}`}
              className={optionsClasses}
              type="button"
              value={optionId}
              onClick={onClick}
              disabled={!isEditing}
            >
              {" "}
              {optionLabelMapValues[index]}{" "}
            </button>
          </div>
        );
      })}
    </div>
  );
};

export const BehavioralGoals = (props) => {
  const { note, editable, editHandler, profileView } = props;

  let goalsObjectivesProgress = note.content.goals_objectives_progress;

  const [isEditing, setIsEditing] = React.useState(false);
  const [editCopy, setEditCopy] = React.useState(_.cloneDeep(goalsObjectivesProgress));

  const handleEditCopyChange = (e, index, key, isNumber = false) => {
    let editCopyClone = _.cloneDeep(editCopy);

    editCopyClone[index][key] = isNumber ? parseInt(e.target.value) : e.target.value;
    setEditCopy(editCopyClone);

    if (editHandler) {
      editHandler("goals_objectives_progress", editCopyClone);
    }
  };

  let content = (
    <>
      <div className="row mx-1 px-1">
        <div className="col-lg-5">
          <p className="clr-sec tw:font-bold">Goals, Objectives, & Progress Towards Goals</p>
        </div>
        <div className="col-lg-3 tw:font-bold">
          <p className="clr-sec tw:font-bold">Actions</p>
        </div>
        <div className="col-lg-4 tw:font-bold">
          <div className="d-flex justify-content-between">
            <p className="clr-sec"> Plan</p>
            {editable && !isEditing && (
              <img
                src={images("./icons/edit-2.svg")}
                alt="Edit Goals, Objectives, Progress"
                style={{
                  width: "30px",
                  height: "30px",
                }}
                onClick={() => setIsEditing((curr) => !curr)}
              />
            )}
            {editable && isEditing && (
              <img
                src={images("./icons/save.svg")}
                alt="Save"
                style={{
                  width: "30px",
                  height: "30px",
                }}
                onClick={() => {
                  setIsEditing((curr) => !curr);
                }}
              />
            )}
          </div>
        </div>
      </div>
      {goalsObjectivesProgress.map((progress, index) => {
        let style = { minHeight: 50 };

        if (index !== goalsObjectivesProgress.length - 1) {
          style.borderBottom = "1px  solid #DAE6EC";
        } else if (index === goalsObjectivesProgress.length - 1 && profileView) {
          style.borderBottom = "2px  solid #DAE6EC";
        }

        return (
          <div key={progress.label + index} className="row mt-1 mx-1 px-1" style={style}>
            <div className="col-lg-5">
              <div>
                {index + 1}. {progress.label}
              </div>

              <div>
                <div className="col-12 d-flex justify-content-start">
                  {Object.values(RATING_OPTIONS_LABEL_MAP).map((optionLabel, labelIndex) => (
                    <div
                      key={optionLabel + labelIndex}
                      className="w-25 fs-10 text-center tw:font-bold"
                    >
                      <div className="m-auto">{optionLabel}</div>
                    </div>
                  ))}
                </div>
                <BehavioralGoalsRating
                  optionLabelMap={RATING_OPTIONS_LABEL_MAP}
                  progress={!editable ? progress : editCopy[index]}
                  isEditing={editable}
                  onClick={(e) => handleEditCopyChange(e, index, "answer", true)}
                />
              </div>
            </div>
            <div className="col-lg-3">
              {!isEditing ? (
                <p>{progress.actions}</p>
              ) : (
                <TextArea
                  value={editCopy[index].actions}
                  onChange={(e) => handleEditCopyChange(e, index, "actions")}
                />
              )}
            </div>
            <div className="col-lg-3">
              {!isEditing ? (
                <p>{progress.plan}</p>
              ) : (
                <TextArea
                  value={editCopy[index].plan}
                  onChange={(e) => handleEditCopyChange(e, index, "plan")}
                />
              )}
            </div>
          </div>
        );
      })}
    </>
  );

  let desktopContent;

  if (!profileView) {
    desktopContent = (
      <CardSecondary className="mx-auto px-3 py-3 mt-3 d-none d-md-none d-lg-block">
        {content}
      </CardSecondary>
    );
  } else {
    desktopContent = <div>{content}</div>;
  }

  let mobileContent = (
    <div className="d-block d-md-block d-lg-none mt-3">
      <div className="d-flex justify-content-between">
        <p className="cmt-3 clr-sec tw:font-bold">Goals, Objectives, & Progress Towards Goals</p>
        {editable && !isEditing && (
          <img
            src={images("./icons/edit-2.svg")}
            alt="Edit Goals, Objectives, Progress"
            style={{
              width: "30px",
              height: "30px",
            }}
            onClick={() => setIsEditing((curr) => !curr)}
          />
        )}
        {editable && isEditing && (
          <img
            src={images("./icons/save.svg")}
            alt="Save"
            style={{
              width: "30px",
              height: "30px",
            }}
            onClick={() => {
              setIsEditing((curr) => !curr);
            }}
          />
        )}
      </div>
      {goalsObjectivesProgress.map((progress, index) => {
        return (
          <CardSecondary key={progress.label + index} className="mx-auto mt-2 px-3 py-3 d-block">
            <div className="col-lg-3 tw:font-bold">
              <p className="clr-sec tw:font-bold">Goal</p>
            </div>
            <div>
              {index + 1}. {progress.label}
            </div>
            <BehavioralGoalsRating
              optionLabelMap={RATING_OPTIONS_LABEL_MAP}
              progress={progress}
              isEditing={isEditing}
              onClick={(e) => handleEditCopyChange(e, index, "answer", true)}
            />

            <div className="col-lg-3 tw:font-bold">
              <p className="clr-sec tw:font-bold">Actions</p>
            </div>
            <div className="col-lg-3">
              {!isEditing ? (
                <p>{progress.actions}</p>
              ) : (
                <TextArea
                  value={editCopy[index].actions}
                  onChange={(e) => handleEditCopyChange(e, index, "actions")}
                />
              )}
            </div>

            <div className="col-lg-4 tw:font-bold">
              <p className="clr-sec tw:font-bold">Plan</p>
            </div>
            <div className="col-lg-3">
              {!isEditing ? (
                <p>{progress.plan}</p>
              ) : (
                <TextArea
                  value={editCopy[index].plan}
                  onChange={(e) => handleEditCopyChange(e, index, "plan")}
                />
              )}
            </div>
          </CardSecondary>
        );
      })}
    </div>
  );

  return (
    <>
      {desktopContent}
      <div className="print-class">{mobileContent}</div>
    </>
  );
};
